import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({
    options,
    size = 'medium',
    height = 14,
    multiple = false,
    clearable = true,
    disabled = false,
    ...args
  }) {
    super(args)
    const child = this.getComponentWithVModel('el-radio-group')
    child.attrs = {
      ...child.attrs,
      disabled,
      size,
      clearable,
      multiple
    }
    child.children = options.map((option, i) => ({
      component: 'el-radio-button',
      attrs: {
        label: option.value,
        key: option.key || i
      },
      children: [
        {
          component: 'img',
          attrs: {
            src: option.label,
            height
          }
        }
      ]
    }))

    if (clearable) {
      child.children.unshift({
        component: 'el-radio-button',
        attrs: {
          label: '',
          key: 'null'
        },
        innerText: 'Brak'
      })
    }

    this.children = [child]
  }
}
